import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize, tap } from 'rxjs';
import { KuboService } from '../services/kubo.service';

/** Peticiones que no son "guardar algo" (sesión, marcar novedades como leídas, vistas previas). */
const IGNORE = [/\/auth\/(refresh|logout|login|forgot|reset|verify)/i, /\/saas\/(session\/|owner-login)/i, /\/novelties\//, /\/preview\b/i, /\/heartbeat\b/i];

/**
 * Kubo reacciona a lo que se guarda en el panel (igual que Lumi): mientras se
 * envía, "pensando"; si sale bien, "éxito"; si falla, "advertencia" (el
 * detalle del error ya lo muestra el aviso del panel). Solo con el Kubo
 * global montado: en el inicio de sesión no hay a quién avisar.
 */
export const kuboActivityInterceptor: HttpInterceptorFn = (req, next) => {
  const isWrite = req.method !== 'GET' && req.method !== 'HEAD' && req.method !== 'OPTIONS';
  if (!isWrite || IGNORE.some(r => r.test(req.url))) return next(req);
  const kubo = inject(KuboService);
  if (!kubo.dockMounted()) return next(req);
  kubo.saving();
  let settled = false;
  return next(req).pipe(
    tap({
      next: event => { if (event instanceof HttpResponse) { settled = true; kubo.saved(); } },
      error: (error: unknown) => {
        settled = true;
        if (error instanceof HttpErrorResponse && error.status === 0) kubo.offline();
        else kubo.failed();
      },
    }),
    // Petición cancelada (se cambió de pantalla): solo vuelve al reposo.
    finalize(() => { if (!settled) kubo.cancelled(); }),
  );
};
